import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from '../static/styles/Home.module.css';
import weeklyTournamentStyles from '../static/styles/WeeklyTournaments.module.css';
import { fetchWeeklyTournaments, fetchEslTournaments } from '../api/tournaments';
import { fetchDailyGames, listEslGames } from '../api/games';
import { fetchHighlights, fetchGameHighlights } from '../api/highlights';
import { getRewardsList } from '../api/rewards';
import { jwtDecode } from 'jwt-decode';

import gamezAcad1 from '../static/img/LearnWin/gamezAcad_1.avif';
import gamezAcad2 from '../static/img/LearnWin/gamezAcad_2.avif';
import gamezAcad3 from '../static/img/LearnWin/gamezAcad_3.avif';

import pubgHighlight from '../static/img/Highlights/pubgHighlight_Portrait.avif';
import freeFireHighlight from '../static/img/Highlights/freeFireHighlight_Portrait.avif';
import codHighlight from '../static/img/Highlights/codHighlight_Portrait.avif';

import calendarIcon from '../static/img/Home/calendarIcon.svg';

import pubgImageDummy from '../static/img/Home/pubgDummy.avif';
import pubgWeekly from '../static/img/Home/pubgWeekly.png';

import pubgIcon from '../static/img/DailyGamingTasks/iconPubgDailyTasks.png';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';

import pubgBg from '../static/img/WeeklyTournaments/imagePubgWeeklyTournament.avif';
import freefireBg from '../static/img/WeeklyTournaments/imageFreeFireWeeklyTournament.avif';

import pubgImage from '../static/img/DailyGamingTasks/imagePubgGaming.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexLegendsGaming.avif';
import codImage from '../static/img/DailyGamingTasks/imageCODGaming.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftGaming.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCGaming.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRGaming.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteGaming.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageAmongUsGaming.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfGaming.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantGaming.avif';
import freeFireImage from '../static/img/DailyGamingTasks/imageFreeFireGaming.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxGaming.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import eightBallPoolImage from '../static/img/DailyGamingTasks/image8BallPool.avif';

import playstation5Img from '../static/img/Rewards/Playstation5_Portrait.png';
import asusRogDeltaSCoreImg from '../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import edifierG1Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG1_Portrait.png';
import asusTufKeyboardImg from '../static/img/Rewards/AsusRA05TUFK3RDUSGamingKeyboard_Portrait.png';
import bloodyB760Img from '../static/img/Rewards/BloodyMechanicalGamingKeyboardB760_Portrait.png';
import asusGladiusImg from '../static/img/Rewards/AsusROGGladiusIIIP514GamingMouse_Portrait.avif';
import pubgImg from '../static/img/Rewards/pubgReward_Portrait.jpg';
import fortniteImg from '../static/img/Rewards/fortniteReward_Portrait.avif';
import minecraftImg from '../static/img/Rewards/minecraftReward_Portrait.jpg';

import aimTrainCover from '../static/img/MadeByESL/aim_train_home.avif';
import aimTrainCoverSmall from '../static/img/MadeByESL/coverAimTrain.avif';
import aimTrainBattle from '../static/img/MadeByESL/aimTrainBattle.avif';
import cannonClashCover from '../static/img/MadeByESL/coverCannonClash.avif';
import cannonClashCoverLarge from '../static/img/MadeByESL/cannon_clash_home.avif';
import puzzleManiaCover from '../static/img/MadeByESL/coverPuzzleMania.avif';
import puzzleManiaCoverLarge from '../static/img/MadeByESL/puzzle_mania_home.avif';
import spaceFootballCover from '../static/img/MadeByESL/coverSpaceFootball.png.avif';
import CannonClashInstructions from '../components/CannonClashInstructions';

import bannerHome from '../static/img/Home/Home.avif';
import bannerLearn from '../static/img/Home/LearnNwin.avif';
import bannerESL from '../static/img/Home/Madebyesl.avif';
import bannerWeekly from '../static/img/Home/Weeklytournaments.avif';
import bannerRewards from '../static/img/Home/WinRewards.avif';
import bannerTasks from '../static/img/Home/Dailytask.avif';
import bannerHighlights from '../static/img/Home/Highlights.avif';
import bannerAimTrain from '../static/img/Home/AimTrainRamadan.avif';

import sectionHeaderBg from '../static/img/Home/section_header_1.png';
import heroSectionBg from '../static/img/Home/hero_section.png';

import icPubg from '../static/img/Home/slider_icons/ic_pubg.png';
import icFreeFire from '../static/img/Home/slider_icons/ic_freefire.png';
import icCod from '../static/img/Home/slider_icons/ic_cod.png';
import icApex from '../static/img/Home/slider_icons/ic_apex.png';
import icMinecraft from '../static/img/Home/slider_icons/ic_minecraft.png';
import icSus from '../static/img/Home/slider_icons/ic_sus.png';
import icCoc from '../static/img/Home/slider_icons/ic_coc.png';
import icSubway from '../static/img/Home/slider_icons/ic_subway.png';
import icFortnite from '../static/img/Home/slider_icons/ic_fortnite.png';
import icValorant from '../static/img/Home/slider_icons/ic_valorant.png';
import icRoyale from '../static/img/Home/slider_icons/ic_royale.png';
import icFifa from '../static/img/Home/slider_icons/ic_fifa.png';
import icRoblox from '../static/img/Home/slider_icons/ic_roblox.png';
import icPool from '../static/img/Home/slider_icons/ic_pool.png';


SwiperCore.use([Autoplay, Pagination]);

const getDailyTaskImage = (gameName, isMobile = false) => {
  const isMediumScreen = window.innerWidth >= 500 && window.innerWidth <= 767;

  switch (gameName.toLowerCase()) {
    case 'clash royale': return clashRoyaleImage;
    case 'call of duty': return codImage;
    case 'pubg mobile': return pubgImage;
    case 'minecraft': return minecraftImage;
    case 'freefire': return freeFireImage;
    case 'fortnite': return fortniteImage;
    case 'apex legends': return apexImage;
    case 'roblox': return robloxImage;
    case 'among us': return amongUsImage;
    case 'fifa mobile': return fifaImage;
    case 'valorant': return valorantImage;
    case 'subway surfers': return subwaySurfersImage;
    case 'clash of clans': return clashOfClansImage;
    case '8 ball pool': return eightBallPoolImage;
    case 'aim train': return isMediumScreen ? aimTrainCover : aimTrainCoverSmall;
    case 'cannon clash': return isMediumScreen ? cannonClashCoverLarge : cannonClashCover;
    case 'puzzle mania': return isMediumScreen ? puzzleManiaCoverLarge : puzzleManiaCover;
    case 'space football': return spaceFootballCover;
    default:
      return null;
  }
};

const getGameIcon = (gameName) => {
  switch (gameName.toLowerCase()) {
    case 'pubg mobile': return pubgIcon;
    case 'freefire': return freeFireIcon;
    default: return null;
  }
};

const getGameBackground = (gameName) => {
  switch (gameName.toLowerCase()) {
    case 'pubg mobile': return pubgBg;
    case 'freefire': return freefireBg;
    default: return null;
  }
};

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return { date: 'N/A', time: 'N/A' };
  const [datePart, timePart, ampm] = dateTimeString.split(' ');
  return {
    date: datePart,
    time: `${timePart} ${ampm}`
  };
};

function Home() {
  const swiperRef = useRef(null);
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeChip, setActiveChip] = useState('ESL Games');
  const [isJcUser, setIsJcUser] = useState(false);

  const chips = ['ESL Games', 'Daily Tasks', 'Tournaments', 'Learn & Win', 'Rewards', 'Highlights'];

  const sectionRefs = {
    'ESL Games': useRef(null),
    'Daily Tasks': useRef(null),
    'Tournaments': useRef(null),
    'Learn & Win': useRef(null),
    'Rewards': useRef(null),
    'Highlights': useRef(null),
  };

  const handleChipClick = (chip) => {
    setActiveChip(chip);
    const element = sectionRefs[chip]?.current;
    if (element) {
      const headerOffset = 50;
      let scrollContainer = element.parentElement;
      while (scrollContainer) {
        const overflow = window.getComputedStyle(scrollContainer).overflow;
        if (overflow === 'auto' || overflow === 'scroll') break;
        scrollContainer = scrollContainer.parentElement;
      }
      if (!scrollContainer || scrollContainer === document.body || scrollContainer === document.documentElement) {
        scrollContainer = window;
      }
      if (scrollContainer === window) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      } else {
        scrollContainer.scrollTo({ top: element.offsetTop - headerOffset, behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [dailyGamesData, setDailyGamesData] = useState([]);
  const [loadingDailyGames, setLoadingDailyGames] = useState(true);
  const [errorDailyGames, setErrorDailyGames] = useState(null);

  const [weeklyTournamentsData, setWeeklyTournamentsData] = useState([]);
  const [eslTournamentsData, setEslTournamentsData] = useState([]);
  const [loadingWeekly, setLoadingWeekly] = useState(true);
  const [errorWeekly, setErrorWeekly] = useState(null);

  const [gameHighlightsData, setGameHighlightsData] = useState([]);
  const [loadingGameHighlights, setLoadingGameHighlights] = useState(true);
  const [errorGameHighlights, setErrorGameHighlights] = useState(null);

  const [eslGames, setEslGames] = useState([]);
  const [loadingEslGames, setLoadingEslGames] = useState(true);
  const [errorEslGames, setErrorEslGames] = useState(null);

  const [rewardsData, setRewardsData] = useState([]);
  const [loadingRewards, setLoadingRewards] = useState(true);
  const [errorRewards, setErrorRewards] = useState(null);

  const [mainSliderBanners, setMainSliderBanners] = useState([]);
  const [showInstructions, setShowInstructions] = useState(false);

  useEffect(() => {
    document.title = "Home | Ufone ESG";

    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setIsJcUser(decodedToken.is_jc === 1);
      } catch (e) {
        setIsJcUser(false);
      }
    }

    const loadWeeklyTournaments = async () => {
      try {
        setLoadingWeekly(true);
        setErrorWeekly(null);
        const [weeklyData, eslData] = await Promise.all([
          fetchWeeklyTournaments(),
          fetchEslTournaments()
        ]);
        setWeeklyTournamentsData(weeklyData);
        setEslTournamentsData(eslData);
      } catch (err) {
        setErrorWeekly(err.message || 'Failed to load tournaments');
      } finally {
        setLoadingWeekly(false);
      }
    };
    loadWeeklyTournaments();
  }, []);

  useEffect(() => {
    const loadRewards = async () => {
      try {
        setLoadingRewards(true);
        setErrorRewards(null);
        const response = await getRewardsList();
        if (response && response.data && Array.isArray(response.data)) {
          setRewardsData(response.data);
        } else {
          setRewardsData([]);
        }
      } catch (err) {
        setErrorRewards(err.message || 'Failed to load rewards');
      } finally {
        setLoadingRewards(false);
      }
    };
    loadRewards();
  }, []);

  useEffect(() => {
    const loadDailyGames = async () => {
      try {
        setLoadingDailyGames(true);
        setErrorDailyGames(null);
        const data = await fetchDailyGames();
        data.forEach(game => getDailyTaskImage(game.game, isMobile));
        setDailyGamesData(data);
      } catch (err) {
        setErrorDailyGames(err.message || 'Failed to load daily games');
      } finally {
        setLoadingDailyGames(false);
      }
    };
    loadDailyGames();
  }, []);

  useEffect(() => {
    const loadGameHighlights = async () => {
      try {
        setLoadingGameHighlights(true);
        setErrorGameHighlights(null);
        const data = await fetchGameHighlights();
        setGameHighlightsData(data);
      } catch (err) {
        setErrorGameHighlights(err.message || 'Failed to load game highlights');
      } finally {
        setLoadingGameHighlights(false);
      }
    };
    loadGameHighlights();
  }, []);

  useEffect(() => {
    const loadEslGames = async () => {
      try {
        setLoadingEslGames(true);
        setErrorEslGames(null);
        const eslGamesResp = await listEslGames();
        let eslGamesArr = [];
        if (
          eslGamesResp &&
          eslGamesResp.success &&
          eslGamesResp.data &&
          Array.isArray(eslGamesResp.data.eslgames)
        ) {
          eslGamesArr = eslGamesResp.data.eslgames.map(eslGame => ({
            ...eslGame,
            game: eslGame.game_name
          }));
        }
        setEslGames(eslGamesArr);
      } catch (err) {
        setErrorEslGames(err.message || 'Failed to load ESL games');
      } finally {
        setLoadingEslGames(false);
      }
    };
    loadEslGames();
  }, []);

  useEffect(() => {
    const baseBanners = [
      { id: 1, image: bannerAimTrain, title: 'AimTrain Championship', navigateTo: '/tournaments' },
      { id: 2, image: bannerHome, title: 'Home', navigateTo: '/' },
      { id: 3, image: bannerLearn, title: 'Learn & Win', navigateTo: '/learn-win' },
      { id: 4, image: bannerESL, title: 'Made by ESG', navigateTo: '/daily-gaming-tasks' },
      { id: 5, image: bannerWeekly, title: 'Weekly Tournaments', navigateTo: '/tournaments' },
      { id: 6, image: bannerRewards, title: 'Rewards', navigateTo: '/rewards' },
      { id: 7, image: bannerTasks, title: 'Daily Tasks', navigateTo: '/daily-gaming-tasks' },
      { id: 8, image: bannerHighlights, title: 'Highlights', navigateTo: '/highlights' },
    ];
    setMainSliderBanners([...baseBanners]);
  }, [isMobile, eslGames]);

  const breakpoints4Slides = {
    0: { slidesPerView: 1, spaceBetween: 15 },
    320: { slidesPerView: 1.4, spaceBetween: 15 },
    400: { slidesPerView: 1.5, spaceBetween: 15 },
    768: { slidesPerView: 3, spaceBetween: 20 },
    1024: { slidesPerView: 4, spaceBetween: 20 }
  };

  const breakpoints3Slides = {
    0: { slidesPerView: 1.1, spaceBetween: 15 },
    768: { slidesPerView: 1.6, spaceBetween: 20 },
    1024: { slidesPerView: 2.3, spaceBetween: 20 }
  };

  const eslGameBreakpoints = {
    0: { slidesPerView: 1, spaceBetween: 15 },
    768: { slidesPerView: 2, spaceBetween: 20 },
    1024: { slidesPerView: 3, spaceBetween: 20 }
  };

  const handleDailyGameClick = (gameId, gameName) => {
    if (!gameId) return;
    if (gameName && gameName.toLowerCase() === 'cannon clash') {
      navigate('/tournaments');
    } else {
      navigate(`/game-challenges?gameId=${encodeURIComponent(gameId)}`);
    }
  };

  const handleInstructionsClose = () => setShowInstructions(false);

  const handleShowInstructions = (gameName) => {
    if (gameName && gameName.toLowerCase().includes('cannon')) {
      setShowInstructions(true);
    }
  };

  const getGameHighlightImage = (gameName) => {
    switch (gameName.toLowerCase()) {
      case 'pubg':
      case 'pubg mobile':
        return pubgHighlight;
      case 'freefire':
        return freeFireHighlight;
      case 'call of duty':
        return codHighlight;
      default:
        return pubgImageDummy;
    }
  };

  const getRewardImage = (rewardId) => {
    const id = parseInt(rewardId);
    switch (id) {
      case 11: return playstation5Img;
      case 12: return asusRogDeltaSCoreImg;
      case 13: return edifierG1Img;
      case 14: return asusTufKeyboardImg;
      case 15: return bloodyB760Img;
      case 16: return asusGladiusImg;
      case 1: case 2: case 3: case 4: return pubgImg;
      case 6: case 7: case 8: return fortniteImg;
      case 9: case 10: return minecraftImg;
      default: return pubgImg;
    }
  };

  const liveEslTournaments = eslTournamentsData.filter(t => {
    if (t.is_live !== 1) return false;
    if (t.tourn_mode === 'special') return false;
    return true;
  });

  return (
    <>
      {/* MAIN SLIDER */}
      <div className={styles.container}>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          autoplay={{ delay: 4000 }}
          loop={mainSliderBanners.length > 1}
          slidesPerView={isMobile ? 1 : 3}
          pagination={{
            el: '.tournament-pagination',
            clickable: true,
          }}
          className="tournament-swiper"
        >
          {mainSliderBanners.map((banner) => (
            <SwiperSlide key={banner.id}>
              <div
                className={styles.slideContainer}
                onClick={
                  banner.isEsl
                    ? banner.onClick
                    : banner.navigateTo
                    ? () => navigate(banner.navigateTo)
                    : undefined
                }
                style={{ cursor: banner.navigateTo || banner.isEsl ? 'pointer' : 'default' }}
              >
                <div
                  className={styles.slideImage}
                  style={{ backgroundImage: `url(${banner.image})` }}
                />
                <div className={styles.overlay} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="tournament-pagination"></div>
      </div>

      {/* ICON MARQUEE */}
      <div className={styles.iconMarquee} style={{ backgroundImage: `url(${heroSectionBg})` }}>
        <div className={styles.iconMarqueeTrack}>
          {[icPubg, icFreeFire, icCod, icApex, icMinecraft, icSus, icCoc, icSubway, icFortnite, icValorant, icRoyale, icFifa, icRoblox, icPool,
            icPubg, icFreeFire, icCod, icApex, icMinecraft, icSus, icCoc, icSubway, icFortnite, icValorant, icRoyale, icFifa, icRoblox, icPool
          ].map((icon, index) => (
            <img key={index} src={icon} alt="" className={styles.iconMarqueeIcon} />
          ))}
        </div>
      </div>

      {/* CHIPS */}
      <div className={styles.chipsContainer}>
        {chips.map((chip) => (
          <button
            key={chip}
            className={`${styles.chip} ${activeChip === chip ? styles.chipActive : ''}`}
            onClick={() => handleChipClick(chip)}
          >
            {chip}
          </button>
        ))}
      </div>

      {/* ESL GAMES */}
      <div ref={sectionRefs['ESL Games']} className={styles.weeklyTasksSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
            <h3 className={styles.sectionHeaderTitle}>Made by ESG</h3>
          </div>
          <div className={styles.sectionHeaderBottom}>
            <p className={styles.sectionHeaderSubtitle}>Play & Earn with ESG Originals</p>
            <button className={styles.viewAllButton} onClick={() => navigate('/daily-gaming-tasks')}>
              <span>View All ›</span>
            </button>
          </div>
        </div>
        {loadingEslGames && <div className={styles.loading}>Loading...</div>}
        {errorEslGames && <div className={styles.error}>Error: {errorEslGames}</div>}
        {!loadingEslGames && !errorEslGames && eslGames.length > 0 && (
          <Swiper
            breakpoints={eslGameBreakpoints}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={eslGames.length > 1}
          >
            {eslGames
              .filter((game) => game.game_status === 1)
              .map((game) => {
                const gameImage = getDailyTaskImage(game.game, isMobile) || pubgImageDummy;
                return (
                  <SwiperSlide key={game.game_unique_id || game.id}>
                    <div
                      onClick={() => handleDailyGameClick(game.gameId || game.game_unique_id, game.game)}
                      className={styles.clickableTaskCard}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => e.key === 'Enter' && handleDailyGameClick(game.gameId || game.game_unique_id, game.game)}
                    >
                      <div className={styles.taskCard}>
                        <div
                          className={styles.madeByESL}
                          style={{ backgroundImage: `url(${gameImage})` }}
                        >
                          {game.game && game.game.toLowerCase().includes('cannon') && (
                            <button
                              className={weeklyTournamentStyles.infoButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShowInstructions(game.game);
                              }}
                              title="View Game Instructions"
                            >
                              <span className={weeklyTournamentStyles.infoIcon}>?</span>
                              <span className={weeklyTournamentStyles.infoText}>How to Play</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}
      </div>

      {/* DAILY TASKS */}
      <div ref={sectionRefs['Daily Tasks']} className={styles.dailyTasksSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
            <h3 className={styles.sectionHeaderTitle}>Gaming Tasks</h3>
          </div>
          <div className={styles.sectionHeaderBottom}>
            <p className={styles.sectionHeaderSubtitle}>Play daily tasks & win extra credits</p>
            <button className={styles.viewAllButton} onClick={() => navigate('/daily-gaming-tasks')}>
              <span>View All ›</span>
            </button>
          </div>
        </div>

        {loadingDailyGames && <div className={styles.loading}>Loading...</div>}
        {errorDailyGames && <div className={styles.error}>Error: {errorDailyGames}</div>}
        {!loadingDailyGames && !errorDailyGames && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={dailyGamesData.length > 4}
          >
            {dailyGamesData.map((game) => {
              const gameImage = getDailyTaskImage(game.game, isMobile) || pubgImageDummy;
              return (
                <SwiperSlide key={game.id}>
                  <div
                    onClick={() => handleDailyGameClick(game.gameId)}
                    className={styles.clickableTaskCard}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === 'Enter' && handleDailyGameClick(game.gameId)}
                  >
                    <div className={`${styles.taskCard} ${styles.dailyTaskCard}`}>
                      <div
                        className={styles.taskImage}
                        style={{ backgroundImage: `url(${gameImage})` }}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      {/* TOURNAMENTS */}
      <div ref={sectionRefs['Tournaments']} className={styles.weeklyTasksSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
            <h3 className={styles.sectionHeaderTitle}>Tournaments</h3>
          </div>
          <div className={styles.sectionHeaderBottom}>
            <p className={styles.sectionHeaderSubtitle}>Win big credits</p>
            <button className={styles.viewAllButton} onClick={() => navigate('/tournaments')}>
              <span>View All ›</span>
            </button>
          </div>
        </div>

        {loadingWeekly && <div className={styles.loading}>Loading...</div>}
        {errorWeekly && <div className={styles.error}>Error: {errorWeekly}</div>}
        {!loadingWeekly && !errorWeekly && (
          <Swiper
            breakpoints={breakpoints3Slides}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 3000 }}
            loop={weeklyTournamentsData.length + liveEslTournaments.length > 3}
          >
            {liveEslTournaments
              .filter(tournament => tournament.status !== 4)
              .map((tournament) => {
                const isCannonClash = tournament.tourn_name && tournament.tourn_name.toLowerCase().includes('cannon');
                const isAimTrain = tournament.tourn_name && tournament.tourn_name.toLowerCase().includes('aim train');
                return (
                  <SwiperSlide key={`esl-${tournament.Id || tournament.id}`}>
                    <div
                      className={styles.weeklyTaskCard}
                      onClick={() => navigate('/tournaments')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        className={styles.weeklyTaskImage}
                        style={{
                          backgroundImage: isCannonClash
                            ? `url(${cannonClashCover})`
                            : isAimTrain
                              ? `url(${aimTrainBattle})`
                              : tournament.thumbnail
                                ? `url(${tournament.thumbnail})`
                                : 'none'
                        }}
                      >
                        {isCannonClash && (
                          <button
                            className={weeklyTournamentStyles.infoButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShowInstructions(tournament.tourn_name);
                            }}
                            title="View Tournament Instructions"
                          >
                            <span className={weeklyTournamentStyles.infoIcon}>?</span>
                            <span className={weeklyTournamentStyles.infoText}>How to Play</span>
                          </button>
                        )}
                        <div className={styles.weeklyTaskDateContainer}>
                          <img src={calendarIcon} alt="calendar" className={styles.dateIcon} />
                          <span className={styles.weeklyTaskDate}>{formatDateTime(tournament.time).date}</span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}

            {weeklyTournamentsData.map((tournament) => {
              const { date } = formatDateTime(tournament.time);
              const gameBgSrc = getGameBackground(tournament.tourn_name);
              return (
                <SwiperSlide key={`weekly-${tournament.id}`}>
                  <div
                    className={styles.weeklyTaskCard}
                    onClick={() => navigate(`/join-tournament?tournamentId=${tournament.tourn_id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className={styles.weeklyTaskImage}
                      style={{ backgroundImage: gameBgSrc ? `url(${gameBgSrc})` : 'none' }}
                    >
                      <div className={styles.weeklyTaskDateContainer}>
                        <img src={calendarIcon} alt="calendar" className={styles.dateIcon} />
                        <span className={styles.weeklyTaskDate}>{date}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      {/* LEARN & WIN */}
      <div ref={sectionRefs['Learn & Win']} className={styles.weeklyTasksSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
            <h3 className={styles.sectionHeaderTitle}>Learn & Win</h3>
          </div>
          <div className={styles.sectionHeaderBottom}>
            <p className={styles.sectionHeaderSubtitle}>Test your gaming mettle</p>
            <button className={styles.viewAllButton} onClick={() => navigate('/learn-win')}>
              <span>View All ›</span>
            </button>
          </div>
        </div>

        <Swiper
          breakpoints={breakpoints3Slides}
          className={styles.weeklyTasksSwiper}
          autoplay={{ delay: 3000 }}
          loop={true}
        >
          {[gamezAcad1, gamezAcad2, gamezAcad3].map((image, index) => (
            <SwiperSlide key={index}>
              <div
                className={styles.weeklyTaskCard}
                onClick={() => window.open('https://gamezacademy.pk/', '_blank')}
                style={{ cursor: 'pointer' }}
              >
                <div
                  className={styles.weeklyTaskImage}
                  style={{ backgroundImage: `url(${image})` }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* REWARDS */}
      <div ref={sectionRefs['Rewards']} className={styles.dailyTasksSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
            <h3 className={styles.sectionHeaderTitle}>Rewards</h3>
          </div>
          <div className={styles.sectionHeaderBottom}>
            <p className={styles.sectionHeaderSubtitle}>Win Gaming Accessories & Currencies</p>
            <button className={styles.viewAllButton} onClick={() => navigate('/rewards')}>
              <span>View All ›</span>
            </button>
          </div>
        </div>

        {loadingRewards && <div className={styles.loading}>Loading...</div>}
        {errorRewards && <div className={styles.error}>Error: {errorRewards}</div>}
        {!loadingRewards && !errorRewards && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={rewardsData.length > 4}
          >
            {rewardsData.map((reward) => {
              const rewardImage = getRewardImage(reward.id);
              const isDigital = [1, 2, 3, 4, 6, 7, 8, 9, 10].includes(parseInt(reward.id));
              return (
                <SwiperSlide key={reward.id || reward.name}>
                  <div className={`${styles.taskCard} ${styles.dailyTaskCard}`}>
                    <div
                      className={styles.taskImage}
                      style={{ backgroundImage: rewardImage ? `url(${rewardImage})` : 'none' }}
                    >
                      {isDigital && (
                        <span className={styles.rewardNameOverlay}>{reward.name}</span>
                      )}
                      <div className={styles.rewardCreditsOverlay}>
                        <span className={styles.rewardCreditsLabel}>CREDITS<br />REQUIRED</span>
                        <span className={styles.rewardCreditsValue}>{reward.credits ? reward.credits.toLocaleString() : 'N/A'}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      {/* HIGHLIGHTS */}
      <div ref={sectionRefs['Highlights']} className={styles.dailyTasksSection}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
            <h3 className={styles.sectionHeaderTitle}>Highlights</h3>
          </div>
          <div className={styles.sectionHeaderBottom}>
            <p className={styles.sectionHeaderSubtitle}>Rewards, Leaderboard, Tournaments highlights</p>
            <button className={styles.viewAllButton} onClick={() => navigate('/highlights')}>
              <span>View All ›</span>
            </button>
          </div>
        </div>

        {loadingGameHighlights && <div className={styles.loading}>Loading...</div>}
        {errorGameHighlights && <div className={styles.error}>Error: {errorGameHighlights}</div>}
        {!loadingGameHighlights && !errorGameHighlights && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={gameHighlightsData.length > 4}
          >
            {gameHighlightsData.map((highlight) => {
              const gameImage = getGameHighlightImage(highlight.game);
              return (
                <SwiperSlide key={highlight.id}>
                  <div
                    className={`${styles.taskCard} ${styles.dailyTaskCard}`}
                    onClick={() => navigate(`/game-highlights?gameId=${highlight.gameId}&gameName=${highlight.game}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className={styles.taskImage}
                      style={{ backgroundImage: `url(${gameImage})` }}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      <CannonClashInstructions
        isOpen={showInstructions}
        onClose={handleInstructionsClose}
      />
    </>
  );
}

export default Home;
